import type { Account, AccountFragmentFragment } from "@/api/generated/graphql";
import { orderedAccountType } from "@/utils/orderedEnums";

export function sortAccounts<T extends Account | AccountFragmentFragment>(accounts?: T[] | null) {
  if (!accounts) {
    return accounts;
  }

  return [...accounts]
    .sort((a, b) => {
      return (a.name ?? "").localeCompare(b.name ?? "");
    })
    .sort((a, b) => {
      return orderedAccountType.indexOf(a.type) - orderedAccountType.indexOf(b.type);
    })
    .sort((a, b) => {
      return (a.external ? 1 : 0) - (b.external ? 1 : 0);
    });
}
